import { BodyText, Card, Flex, Heading } from '@utilitywarehouse/hearth-react';
import clsx from 'clsx';
import { ReactNode } from 'react';

import { CopyButton } from '@components/CopyButton';

import { SHARE_URL } from '../constants';

interface LinkShareProps {
  preview: string;
  url: string;
  onCopy: () => void;
}

interface ShareBoxProps {
  title?: string | null;
  content: string;
  className?: string;
  children?: ReactNode;
  testId?: string;
}

const ShareBox = ({
  title = null,
  content,
  className = '',
  children,
  testId,
}: ShareBoxProps) => {
  return (
    <Card
      direction="column"
      variant="subtle"
      colorScheme="brand"
      className={clsx('invite__Share', className)}
    >
      {title && (
        <BodyText size="lg" className="invite__ShareTitle">
          {title}
        </BodyText>
      )}
      <Flex direction="column" gap="150">
        <Heading
          as="h2"
          className="invite__ShareLinkPreview"
          wrap="wrap"
          data-testid={testId}
        >
          {content}
        </Heading>
        {children}
      </Flex>
    </Card>
  );
};

interface InviteValuesProps {
  code: string;
  personLabel: string;
  isRemoteSupport?: boolean;
}

const LinkShare = ({ preview, url, onCopy }: LinkShareProps) => {
  return (
    <ShareBox content={preview} className="invite__CopyLink">
      <CopyButton
        buttonProps={{
          size: 'sm',
          variant: 'outline',
          colorScheme: 'functional',
        }}
        label="Copy Link"
        value={url}
        onCopy={onCopy}
      />
    </ShareBox>
  );
};

const InviteValues = ({
  code,
  personLabel,
  isRemoteSupport,
}: InviteValuesProps) => {
  const baseUrl = process.env.BASE_URL;
  const linkBase = `${location.host}${baseUrl ?? '/'}`;

  const joinLinkBase = `${linkBase}remote/join/${code}`;
  return (
    <>
      <div className="invite__Items">
        {!isRemoteSupport && <ShareBox title="Website" content={SHARE_URL} />}
        <ShareBox
          title="Appointment code"
          content={code}
          testId="invite-appointment-code"
        />
      </div>

      {!isRemoteSupport && (
        <>
          <BodyText>
            Alternatively, you can simply send the link below to your{' '}
            {personLabel}:
          </BodyText>
          <LinkShare
            preview={joinLinkBase}
            url={`${location.protocol}//${joinLinkBase}`}
            onCopy={() => {}}
          />
        </>
      )}
    </>
  );
};

export { InviteValues };
